export const success_stories = [
    {
        "name": "Sara Johnson",
        "image": "https://plus.unsplash.com/premium_photo-1683121366070-5ceb7e007a97?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
        "video_url": "https://youtu.be/eTHOaVubu48?si=QPekeRWWcIcrqRnB"
    },
    {
        "name": "Raj Patel",
        "image": "https://images.unsplash.com/photo-1633332755192-727a05c4013d?q=80&w=1780&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
        "video_url": "https://youtu.be/eTHOaVubu48?si=QPekeRWWcIcrqRnB"
    },
    {
        "name": "Emily Chen",
        "image": "https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?q=80&w=1780&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
        "video_url": "https://youtu.be/eTHOaVubu48?si=QPekeRWWcIcrqRnB"
    },
    {
        "name": "Alexis Garcia",
        "image": "https://images.unsplash.com/photo-1494790108377-be9c29b29330?q=80&w=1887&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
        "video_url": "https://youtu.be/eTHOaVubu48?si=QPekeRWWcIcrqRnB"
    },
    {
        "name": "Mohammed Khan",
        "image": "https://plus.unsplash.com/premium_photo-1669882305273-674eff6567af?q=80&w=1887&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
        "video_url": "https://youtu.be/eTHOaVubu48?si=QPekeRWWcIcrqRnB"
    },
    {
        "name": "Sophie Lee",
        "image": "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
        "video_url": "https://youtu.be/eTHOaVubu48?si=QPekeRWWcIcrqRnB"
    },
    {
        "name": "Carlos Ramirez",
        "image": "https://images.unsplash.com/photo-1568602471122-7832951cc4c5?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
        "video_url": "https://youtu.be/eTHOaVubu48?si=QPekeRWWcIcrqRnB"
    },
    {
        "name": "Aisha Patel",
        "image": "https://plus.unsplash.com/premium_photo-1664298528358-790433ba0815?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
        "video_url": "https://youtu.be/eTHOaVubu48?si=QPekeRWWcIcrqRnB"
    },
    {
        "name": "David Smith",
        "image": "https://images.unsplash.com/photo-1546961329-78bef0414d7c?q=80&w=1887&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
        "video_url": "https://youtu.be/eTHOaVubu48?si=QPekeRWWcIcrqRnB"
    },
    {
        "name": "Fatima Ali",
        "image": "https://images.unsplash.com/photo-1484863137850-59afcfe05386?q=80&w=2071&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
        "video_url": "https://youtu.be/eTHOaVubu48?si=QPekeRWWcIcrqRnB"
    }
]
